import {
    TOGGLE_MODAL,
    TOGGLE_STUDENT_OVERLAY,
    SHOW_NOTIFICATION,
    HIDE_NOTIFICATION,
    CLEAR_ERRORS,
    SET_VISIBLE_UNIT,
    SERVER_NOTIFICATIONS,
    PLATFORM_NOTIFICATIONS,
    OPEN_NOTIFICATION,
    SET_DIALOG_PREVIEW,
    TOGGLE_ADMIN_VIEW,
    SET_HEADER_LABEL,
} from './actionTypes';
import Notification from 'components/UI/Notification';
import axios from 'config/axios';
import { GET_ERRORS } from './actionTypes';

export const toggleModal = (modalState, modalName) => {
    return {
        type: TOGGLE_MODAL,
        payload: { showModal: modalState, dashboardModal: modalName },
    };
};

export const toggleStudentOverlay = (overlayState) => {
    return {
        type: TOGGLE_STUDENT_OVERLAY,
        payload: { studentOverlay: overlayState },
    };
};

export const setVisibleUnit = (unitId) => {
    return {
        type: SET_VISIBLE_UNIT,
        payload: { unitId },
    };
};

export const toggleAdminView = (adminView) => {
    return {
        type: TOGGLE_ADMIN_VIEW,
        payload: { adminView },
    };
};

export const setHeaderLabel = (headerLabel) => {
    return {
        type: SET_HEADER_LABEL,
        payload: { headerLabel },
    };
};

export const showNotification = (notificationType, content) => (dispatch) => {
    dispatch(showNotificationTimeOut(notificationType, content));

    setTimeout(() => {
        dispatch(hideNotification());
    }, 8000);
};

export const showServerNotification = (content, children, timeOut, onClick, type) => (dispatch) => {
    dispatch(showServerNotificationTimeOut(content, children, timeOut, onClick, type));
};

export const showServerNotificationTimeOut = (content, children, timeOut, onClick, type) => {
    return {
        type: SERVER_NOTIFICATIONS,
        payload: { content: content, children: children, timeOut, onClick, type },
    };
};

export const showNotificationTimeOut = (notificationType, content) => {
    return {
        type: SHOW_NOTIFICATION,
        payload: { notificationType: notificationType, content: content },
    };
};

export const hideNotification = () => {
    return {
        type: HIDE_NOTIFICATION,
    };
};

export const cleanError = () => {
    return {
        type: CLEAR_ERRORS,
    };
};

export const showPrintingInstruction = () => (dispatch) => {
    dispatch(showNotification(Notification.INFO, 'Use "Ctrl + P" or "Cmd + P" to print this page content.'));
};

export const platformNotifications = (data, level, levelId) => {
    return {
        type: PLATFORM_NOTIFICATIONS,
        payload: { data: data, level: level, levelId },
    };
};

export const sendSchoolNotifications = (notificationObject) => async (dispatch) => {
    try {
        await axios
            .post(`api_v2/schools/notification/${notificationObject.schoolId}`, {
                notificationTitle: notificationObject.notificationTitle,
                notificationMessage: notificationObject.notificationMessage,
            })
            .then((res) => {
                dispatch(showServerNotification('Notification sent to school', [], 5000, null));
            });
    } catch (err) {
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data,
        });
        dispatch(showNotification(Notification.DANGER, 'Failed to send notification to school'));

        return err;
    }
};

export const sendBulkClassNotifications = (notificationObject, classesArray) => async (dispatch) => {
    try {
        await axios.post(`api_v2/schools/classes/notification`, { notificationObject, classesArray }).then((res) => {
            dispatch(showServerNotification('Notification sent to school', [], 5000, null));
        });
    } catch (err) {
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data,
        });
        dispatch(showNotification(Notification.DANGER, 'Failed to send notification to school'));

        return err;
    }
};

export const openNotification = (notificationObject) => {
    return {
        type: OPEN_NOTIFICATION,
        payload: notificationObject,
    };
};

export const setDialogPreview = (value) => {
    return {
        type: SET_DIALOG_PREVIEW,
        payload: value,
    };
};
